



































































































// vue
import { computed, defineComponent, ref, Ref } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Select2 } from '@/components/form'

// hooks
import { useEmployeesOp } from '@/hooks'

// libs
import { dateLibs } from '@/utils'
import moment from 'moment'

// constants
import {
    optionsWorkType,
    optionsWorkCategory,
    APP_URL_API
} from '@/constants'

export default defineComponent({
  name: 'PaymentSlips',
  components: {
    PageHeader,
    Select2
  },
  setup () {
    const title = 'Boletas de pago'
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Boletas de pago',
        active: true
      }
    ]
    const currentDate = moment()
    const year: Ref<number> = ref(currentDate.year())
    const month: Ref<number> = ref(currentDate.month() - 1)
    const fortnight: Ref<number> = ref(1)

    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault2
    const workType: Ref<number> = ref(0)
    const workCategory: Ref<number> = ref(0)
    const employee: Ref<number> = ref(0)

    const { employeesOp, getEmployees, loadingEmployees } = useEmployeesOp()
    getEmployees()

    const urlReport = computed(() => {
      return `${APP_URL_API}reports/payment-slips?year=${year.value}&month=${month.value}&fortnight=${fortnight.value}&workType=${workType.value}&workCategory=${workCategory.value}&employees=${employee.value}`
    })
    return {
      title,
      breadcrumbs,
      year,
      month,
      fortnight,
      years,
      months,
      fortnights,
      optionsWorkType,
      optionsWorkCategory,
      workType,
      workCategory,
      employeesOp,
      loadingEmployees,
      employee,
      urlReport
    }
  }
})
